import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {IConfigureWizard, IWorkflowStepComponent} from '@shared/interfaces/workflow-step.interface';
import {WorkflowModel, WorkflowState} from '../../../../workflow/models/workflow.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Observable, Subject} from 'rxjs';
import {CommandService} from '@core/services/command.service';
import {WorkflowWizardComponent} from '../../../../workflow/components/workflow-wizard/workflow-wizard.component';
import {Configuration} from '@shared/models/configuration';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {take, takeUntil} from 'rxjs/operators';
import {QueryModel} from '@shared/models/query-model';
import {IQueryState} from '@shared/store/reducers/query.reducer';

@Component({
    standalone: false,
    selector: 'particle-select-report-field-step',
  templateUrl: './select-report-field-step.component.html',
  styleUrls: ['./select-report-field-step.component.scss']
})
export class SelectReportFieldStepComponent implements OnInit, OnDestroy, IWorkflowStepComponent, IConfigureWizard  {
  private workflow: WorkflowModel;
  private currentStep: WorkflowState;
  selectedFieldSectionIndex: number;
  private selectedSection: any;
  invalidateSubject = new InvalidateSubject();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private reportId: string;
  report: any;
  private wizard: WorkflowWizardComponent;
  private currentSectionConfig: any;
  private genericReportByIdKey = 'GenericReportById';
  private queryModels: QueryModel[] = [];
  private response$: Observable<any>;
  constructor(public changeDetectorRef: ChangeDetectorRef,
              private commandService: CommandService,
              private queryStore: Store<IQueryState>) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {

  }

  onLoad(workflow: WorkflowModel, currentStep: WorkflowState) {
    this.workflow = workflow;
    this.currentStep = currentStep;
    const reportIdInput = workflow.States[0].Inputs.find(o => o.Name === 'ReportId');
    if (reportIdInput) {
      this.reportId = reportIdInput.Value;
      this.queryModels.push(QueryProvider.getQuery(this.genericReportByIdKey));
      this.response$ = this.queryStore.pipe(select(getQueryResponse, this.genericReportByIdKey));
      this.response$.pipe(take(2)).subscribe(report => {
        if (report) {
          this.report = report;
          this.selectedFieldSectionIndex = 0;
          this.onTabIndexChange(this.selectedFieldSectionIndex);
          console.log('Report Model', this.report);
        }
      });
      QueryProvider.invokeQuery(this.queryStore, this.genericReportByIdKey, {'[Id]': this.reportId});
    }
  }
  onTabIndexChange(event) {
    this.selectedFieldSectionIndex = event;
    this.selectedSection = this.report.definitionSections[event];
    if (this.selectedSection && this.selectedSection.config && this.selectedSection.config.Editor === 'DataSurveyFieldDefinitionSelectorComponent') {
      this.setVirtualGridParameters();
    }
    if (this.wizard) {
      this.wizard.hasTabs = this.report.definitionSections.length > 1;
    }
  }
  setVirtualGridParameters() {
    this.currentSectionConfig = Configuration.getSmartGridConfig(this.selectedSection.config.ConfigKey);
    this.currentSectionConfig.Parameters['EXECUTION_ID'] = this.selectedSection.config.EXECUTION_ID;
    this.invalidateSubject.invalidate();
  }
  canMoveNext$(): Observable < boolean > {
    return null;
  }
  canMoveNext(): boolean {
    if (!this.report.definitionSections || this.report.definitionSections.length === 0 ) {
      return false;
    }
    if (this.selectedFieldSectionIndex < this.report.definitionSections.length - 1) {
      this.selectedFieldSectionIndex++;
      this.onTabIndexChange(this.selectedFieldSectionIndex);
      return false;
    }
    return true;
  }
  canCancel(): boolean {
    return true;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onGridCellValueChange($event) {

  }
  setWizard(wizard: WorkflowWizardComponent) {
    this.wizard = wizard;
  }
}
